
import arrowdownlong from "../../images/arrow-down-long.svg";
import armanilogo from "../../images/armani-logo.png";
import armanibeach from "../../images/armanibeach.png";
import luxurybeach from "../../images/luxurybeach.png";
import gio from "../../images/gio.png";
import plan1 from "../../images/plan-1.png";
import plan2 from "../../images/plan-2.png";
import plan3 from "../../images/plan-3.png";
import plan4 from "../../images/plan-4.png";
import shareic from "../../images/share-ic.svg";
import residenar from "../../images/residenar.png";
import arrow from "../../images/arrow.svg";



function Details() {

    return (
    <>
         <div class="modal_box2 mb-5">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content" style={{width:'1132px', padding:'0px', overflowY:'scroll', height:'800px'}}>
                <div class="modal_boxbrochure" style={{padding:'50px'}}>
                    <div class="row">
                    <div class="col-md-8">
                        <h4>WEBSITE - ARMANI RESIDENCES</h4>
                    </div>
                    <div class="col-md-4 text-end">
                        <button className="arrowdn"><img src={shareic} alt="arrow" /></button>
                        <button className="arrowdn" ><img src={arrow} alt="arrow" /></button>
                    </div>
                    <div className="col-md-12">
                        <div className="logo_bro_pro"> <img src={armanilogo} alt="arrow" /> </div>
                    </div>
                    </div>
                </div>
                <div className="col-md-12"> <img src={residenar} alt="arrow" style={{width:'100%'}} /> </div>
                <div className="ultimate_beach">
                    <h4>WELCOME TO</h4>
                    <h2>The Ultimate Beach <br/>
                    Residences Experience <br/>
                    on Dubai Palm Jumeirah
                    </h2>
                    <p>An Ultra-Luxury Landmark <br/>
                    collection of Beach Residences on <br/>
                    Dubai Palm Jumeirah, Designed by <br/>
                    Tadao Ando
                    </p>
                    <a href="#" className="button_register">REGISTER</a> 
                </div>
            </div>
        </div>
        </div>
        <div class="modal_box2 mb-5">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content" style={{width:'1132px', padding:'0px', overflowY:'scroll', height:'800px'}}>
                <div class="modal_boxbrochure" style={{padding:'50px'}}>
                    <div class="row">
                    <div class="col-md-8">
                        <h4>BROCHURE - ARMANI RESIDENCES</h4>
                    </div>
                    <div class="col-md-4 text-end">
                        <button className="arrowdn"><img src={arrowdownlong} alt="arrow" /></button>
                        <button className="arrowdn"><img src={arrow} alt="arrow" /></button>
                    </div>
                    <div className="col-md-12">
                        <div className="logo_bro_pro"> <img src={armanilogo} alt="arrow" /> </div>
                    </div>
                    </div>
                </div>
                <div className="bg_resid text-center">
                    <img src={armanibeach} alt="arrow" style={{width:'100%'}} />
                    <h2>Armani Beach Residences</h2>
                </div>
                <div className="luxonplam">
                    <div className="d-flex align-items-center">
                    <div className="col-md-5 p-4">
                        <h5>Luxury Penthouse on Palm Jumeirah</h5>
                        <p>It is hard to imagine a luxury property more impressive than this extraordinary five-bedroom Presidential penthouse apartment in the Armani Beach Residences, Palm Jumeirah. </p>
                    </div>
                    <div className="col-md-7"> <img src={luxurybeach} alt="arrow" style={{width:'100%'}} /> </div>
                    </div>
                </div>
                <div className="gio_img"> <img src={gio} alt="arrow" style={{width:'100%'}} /> </div>
            </div>
        </div>
        </div>
        <div class="modal_box2 mb-5">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content" style={{width:'1132px', padding:'0px', overflowY:'scroll', height:'800px'}}>
                <div class="modal_boxbrochure" style={{padding:'50px'}}>
                    <div class="row">
                    <div class="col-md-8">
                        <h4>FLOOR PLAN - ARMANI RESIDENCES</h4>
                    </div>
                    <div class="col-md-4 text-end">
                        <button className="arrowdn"><img src={arrowdownlong} alt="arrow" /></button>
                        <button className="arrowdn"><img src={arrow} alt="arrow" /></button>
                    </div>
                    <div className="col-md-12">
                        <div className="logo_bro_pro"> <img src={armanilogo} alt="arrow" /> </div>
                    </div>
                    </div>
                    <div className="row">
                    <div className="col-md-6 pt-5"> <img src={plan1} alt="arrow" style={{width:'100%'}} /> </div>
                    <div className="col-md-6 pt-5"> <img src={plan2} alt="arrow" style={{width:'100%'}} /> </div>
                    <div className="col-md-12 pt-5"> <img src={plan3} alt="arrow" style={{width:'100%'}} /> </div>
                    <div className="col-md-12 pt-5"> <img src={plan4} alt="arrow" style={{width:'100%'}} /> </div>
                    </div>
                </div>
            </div>
        </div>
        </div>
    </>
    );
}

export default Details;